import { TAccount } from './accounts.types';

/**
 * Gets the status on the account
 * @param account: TAccount- An Account object
 * @returns loan_status
 */
export const getAccountStatus = (
    account: TAccount
): TAccount['loan_status'] => {
    return account.loan_status;
};
